export default {
  reports: {
    header: {
      title: 'Search activity',
    },
    body: {
      filters: {
        placeholders: {
          search: 'Search by item description or name of the purchasing company',
          category: 'Enter category',
          buyer: 'Enter buying company',
          search_type: 'Enter search type',
          date_range: 'Select an interval of maximum 3 months.',
        },
      },
      actions: {
        search: 'Search',
        excel: 'Generate Excel',
      },
      graph: {
        title: {
          part_1: 'Your products have appeared',
          part_2: 'times',
          part_3: 'between',
        },
      },
      table: {
        columns: {
          date: 'Date',
          user: 'User',
          buyer: 'Buyer Company',
          keyword: 'Searched word',
          item: 'Item',
          sku: 'Sku',
          price: 'Price',
          code: 'Code',
          category: 'Category',
          search_type: 'Search type',
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/reports.js